import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { SecuritizePage } from '@securitize/ui-components';
import { Col, Row } from 'reactstrap';
import PendingInvestmentCard from './components/PendingInvestment';
import { getOpportunityDepositAddresses } from './actions';
import DepositAddresses from './components/DepositAddresses';
import Footer from '../Footer';
import { translate } from '../../../../../i18n/Translate';
import ExitProcess from '../ExitProcess';
import { getOpportunity } from '../OpportunitiesDetailsPage/actions';

const PaymentPage = ({
  getOpportunityDepositAddresses: getOpportunityDepositAddressesAction, isLoading, isLoadingOpportunity, isError, data,
  opportunityId, previousPage, getOpportunity: getOpportunityAction, pageNumber, user, opportunityIsBrokerDealer,
  routesLength, additionalAccreditation,
}) => {
  const history = useHistory();
  useEffect(() => {
    if (!isLoading) getOpportunityDepositAddressesAction(opportunityId);
    if (!isLoadingOpportunity) getOpportunityAction(opportunityId);
  }, []);

  const isMarkets = opportunityIsBrokerDealer && user.isBrokerDealer && user.bdAccountStatus === 'approved';
  const pendingInvestment = data.length === 0;
  const accountApproved = !opportunityIsBrokerDealer || isMarkets;
  const showAddresses = !pendingInvestment && accountApproved;

  return (
    <SecuritizePage isLoading={isLoading} isError={isError}>
      <div className="mb-5">
        <ExitProcess />
      </div>
      {
        showAddresses
          ? (
            <DepositAddresses
              opportunityId={opportunityId}
              addresses={data}
              pageNumber={pageNumber}
              totalSteps={routesLength}
              additionalAccreditation={additionalAccreditation}
            />
          )
          : (
            <PendingInvestmentCard
              pageNumber={pageNumber}
              totalSteps={routesLength}
              additionalAccreditation={additionalAccreditation}
            />
          )
      }
      <Row className="mt-5 mx-0">
        <Col xs={12} md={7} className="pl-0">
          <Footer
            onBack={data.length ? null : () => history.push(previousPage)}
            continueText={translate('Texts.see-other-opportunities')}
            onContinue={() => history.push('/opportunities')}
          />
        </Col>
      </Row>
    </SecuritizePage>
  );
};

PaymentPage.defaultProps = {
  getOpportunityDepositAddresses: () => undefined,
  getOpportunity: () => undefined,
  opportunityId: '',
  isError: false,
  isLoading: false,
  isLoadingOpportunity: false,
  data: [],
  pageNumber: '',
  previousPage: '',
  user: {},
  opportunityIsBrokerDealer: false,
};

PaymentPage.propTypes = {
  getOpportunityDepositAddresses: PropTypes.func,
  getOpportunity: PropTypes.func,
  opportunityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  isLoadingOpportunity: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.any),
  pageNumber: PropTypes.number,
  previousPage: PropTypes.string,
  user: PropTypes.objectOf(PropTypes.any),
  opportunityIsBrokerDealer: PropTypes.bool,
  routesLength: PropTypes.number.isRequired,
  additionalAccreditation: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
  const { investment: { depositAddresses, opportunity, opportunityWizard }, auth } = state;
  const { isLoading, isError, data } = depositAddresses;
  return {
    isLoading,
    isLoadingOpportunity: opportunity.isLoading,
    isError,
    data,
    user: auth.user,
    opportunityIsBrokerDealer: opportunity.data.isBrokerDealer,
    additionalAccreditation: opportunityWizard.data.additionalAccreditation,
  };
};

export default connect(
  mapStateToProps,
  { getOpportunityDepositAddresses, getOpportunity },
)(PaymentPage);
